import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetPasswordState } from "../../redux/slices/passwordSlice";

const PasswordResetPopup = () => {
  const { passwordExpired, expiredAt } = useSelector((state) => state.password);
  const dispatch = useDispatch();

  if (!passwordExpired) return null;

  const handleResetClick = () => {
    dispatch(resetPasswordState());
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full mx-4 animate-fade-in">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">🔒 Please Change Your Default Password</h2>
        <p className="text-gray-600 mb-6">
          Please reset it to continue using your account.
        </p>
        <div className="flex justify-end gap-2">
          <button
            onClick={handleResetClick}
            className="px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium transition"
          >
            ok
          </button>
        </div>
      </div>
    </div>
  );
};

export default PasswordResetPopup;
